import * as BaseService from '@/service/BaseService'

const getConstObj = function(){
  const constObj = sessionStorage.getItem('const_obj')
  if(constObj !== null){
    return JSON.parse(constObj)
  }
  return null
}

let constants = {
  TITLE: 'Acheter²',
  MAX_UPLOAD_SIZE: getConstObj()?.MAX_UPLOAD_SIZE,
  PAGE_SIZE: getConstObj()?.PAGE_SIZE,
  PAGE_SIZES: getConstObj()?.PAGE_SIZES,
  IMAGE_BASEURL:'https://d16511ywy1aud9.cloudfront.net',
  IMAGE_TYPE: getConstObj()?.IMAGE_TYPE,
  ROLE_ID:{
    SYS_CHIEF_ADMIN:'1',
    SYS_ADMIN:'2',
    MER_CHIEF_ADMIN:'3',
    MER_ADMIN:'4',
    MER_KEEPER:'5',
    MER_TREASUER:'6',
    USER:'7',
  },
  REFRESH_TIME: getConstObj()?.REFRESH_TIME,
  COMMODITY_TYPE_IMG:'/commodityTypeImg/',
  USER_AVATAR_IMG:'/userAvatarImg/',
  COMMODITY_IMG:'/commodityImg/',
  CAROUSEL_IMG:'/carouselImg/',
  APK_URL:'APKURL',
  APP_APK_URL:'APPAPKURL',
}

const ConstantsPlugin = {
  install(Vue) {
    Vue.prototype.$constants = constants
  }
}

const loadData = function(){
  if(constants.MAX_UPLOAD_SIZE !== null && typeof(constants.MAX_UPLOAD_SIZE) !== 'undefined'){
    return
  }
  BaseService.getBaseData().then((res)=>{
    let constObj = {}
    for(let one of res){
      if(one.baseDataName === 'MAX_UPLOAD_SIZE'){
        constants.MAX_UPLOAD_SIZE = Number(one.baseDataVal)
        constObj.MAX_UPLOAD_SIZE = Number(one.baseDataVal)
      }
      if(one.baseDataName === 'PAGE_SIZE'){
        constants.PAGE_SIZE = Number(one.baseDataVal)
        constObj.PAGE_SIZE = Number(one.baseDataVal)
      }
      if(one.baseDataName === 'IMAGE_TYPE'){
        constants.IMAGE_TYPE = one.baseDataVal.split('|')
        constObj.IMAGE_TYPE = one.baseDataVal.split('|')
      }
      if(one.baseDataName === 'PAGE_SIZES'){
        let vals = one.baseDataVal.split('|')
        let pageSizes = []
        for(let oneVal of vals){
          pageSizes.push(Number(oneVal))
        }
        constants.PAGE_SIZES = pageSizes
        constObj.PAGE_SIZES = pageSizes
      }
      if(one.baseDataName === 'REFRESH_TIME'){
        constants.REFRESH_TIME = Number(one.baseDataVal)
        constObj.REFRESH_TIME = Number(one.baseDataVal)
      }
    }
    sessionStorage.setItem('const_obj',JSON.stringify(constObj))
  })
}

export {
  ConstantsPlugin,
  loadData
}